import React, { useEffect, useState } from "react";
import Footer from "../Components/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../Components/Sidebar";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";
import AuthPrompt from "../Components/AuthPrompt";
import "../Components/userModals.css";

const ConfirmBooking = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const API_URL = "/api";
  const [cartItems, setCartItems] = useState([]);
  const [addons, setAddons] = useState([]);
  const [user, setUser] = useState(null);
  const [showAuthPrompt, setShowAuthPrompt] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const loadData = () => {
      let cartData = JSON.parse(localStorage.getItem("cart")) || [];
      if (!Array.isArray(cartData)) cartData = [cartData];

      setCartItems(cartData);

      let addonsData = JSON.parse(localStorage.getItem("selectedAddons")) || [];
      if (Array.isArray(addonsData)) {
        addonsData = addonsData.map(item => 
          typeof item === "string" ? JSON.parse(item) : item
        );
      }
      setAddons(addonsData);

      setUser(JSON.parse(localStorage.getItem("user")));
    };

    loadData();

    window.addEventListener("focus", loadData); // ✅ important

    return () => {
      window.removeEventListener("focus", loadData);
    };
  }, []);

  useEffect(() => {
    const addonsData = JSON.parse(localStorage.getItem("selectedAddons")) || [];
    setAddons(addonsData);
  }, [location]);

  useEffect(() => {
    
    let addonsData = JSON.parse(localStorage.getItem("selectedAddons")) || [];
    if (Array.isArray(addonsData)) {
      addonsData = addonsData.map(item => 
        typeof item === "string" ? JSON.parse(item) : item
      );
    }
    setAddons(addonsData);
  }, [location]);

  useEffect(() => {
    if (!showThankYou) {
      return undefined;
    }

    setCountdown(5);
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          localStorage.removeItem("cart");
          localStorage.removeItem("selectedAddons");
          navigate("/");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [showThankYou, navigate]);


  // ✅ EMPTY CHECK
  if (cartItems.length === 0) {
    return <h3 style={{ textAlign: "center" }}>No Booking Found</h3>;
  }

  // ✅ BASE TOTAL
  const baseTotal = cartItems.reduce(
    (sum, item) => sum + (item.price || 0),
    0
  );

  // ✅ ADDONS
  const addonTotal = (Array.isArray(addons) ? addons : []).reduce((total, item) => {
    if (!item || typeof item !== "object") {
      return total;
    }
    return total + (Number(item.price) || 0) * (Number(item.quantity) || 0);
  }, 0);


  // ✅ TAX
  const tax = (baseTotal + addonTotal) * 0.18;

  // ✅ FINAL TOTAL
  const total = baseTotal + addonTotal + tax;

  // ✅ CONFIRM BOOKING (FIXED)
  const handleConfirmBooking = async () => {
    const userData = JSON.parse(localStorage.getItem("user") || "null");

    if (!userData || !(userData._id || userData.id || userData.email)) {
      setShowAuthPrompt(true);
      return;
    }

    if (saving) {
      return;
    }

    setSaving(true);

    try {
      const bookingPayload = {
        customerId: userData._id || userData.id || "",
        customerName: userData.name || "Guest User",
        email: userData.email || userData.emailId || "",
        mobile: userData.mobile || userData.mobileNumber || "",
        totalAmount: baseTotal,
        taxAmount: tax,
        finalAmount: total,
        addonTotal: addonTotal,
        bookingDetails: cartItems.map((item) => ({
          boatId: item.id,
          boatName: item.boatName,
          bookingDate: item.date,
          timeSlot: item.time,
          location: item.location,
          price: item.price,
        })),
        addons: (Array.isArray(addons) ? addons : [])
          .filter((item) => item && typeof item === "object")
          .map((item) => ({
            name: item.name || "",
            type: item.type || "",
            category: item.category || "",
            quantity: Number(item.quantity) || 0,
            price: Number(item.price) || 0,
          })),
      };

      const res = await fetch(`${API_URL}/bookings`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(bookingPayload),
      });

      const data = await res.json();

      if (res.ok && data.success) {
        setShowThankYou(true);
      } else {
        alert(data.message || "Booking failed");
      }
    } catch (error) {
      console.error(error);
      alert("Something went wrong");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      {/* <Header /> */}
      <IndiaBoatsTopBar />
      <PremiumNavbar />

      <section className="booking-summary-container">
        <div className="confirm_start">

          <button
            onClick={() => navigate("/addons")}
            className="th-btn style3 th-icon"
          >
            Back
          </button>
          <h2 className="summary-heading"> {"      "}Confirm Your Booking Details</h2>
        </div>

        <div className="summary-content-grid">

          {/* LEFT SIDE */}
          <div className="summary-details-column">

            {/* USER DETAILS */}
            <div className="summary-group">
              <h3 className="group-title">Customer Details</h3>

              <div className="detail-row">
                <span>Name:</span>
                <span>{user?.name || "Guest User"}</span>
              </div>

              <div className="detail-row">
                <span>Mobile:</span>
                <span>{user?.mobile || user?.mobileNumber || "-"}</span>
              </div>

              <div className="detail-row">
                <span>Email:</span>
                <span>{user?.email || user?.emailId || "-"}</span>
              </div>
            </div>

            {/* BOAT DETAILS */}
            <div className="summary-group summary-group-primary">
              <h3 className="group-title">Yacht & Slot Details</h3>

              {cartItems.map((item, index) => (
                <div key={index} style={{ marginBottom: 15 }}>

                  <div className="detail-row">
                    <span>Yacht:</span>
                    <span>{item.boatName}</span>
                  </div>

                  <div className="detail-row">
                    <span>Date & Time:</span>
                    <span>{item.date} ({item.time})</span>
                  </div>

                  <div className="detail-row">
                    <span>Location:</span>
                    <span>{item.location}</span>
                  </div>

                  <div className="detail-row">
                    <span>Price:</span>
                    <span>₹ {item.price}</span>
                  </div>

                  <hr />
                </div>
              ))}
            </div>
            <div className="summary-group summary-group-primary">
              <h3 className="group-title">Selected Add-Ons</h3>

              {addons && addons.length > 0 ? (
                addons.map((item, index) => (
                  <div key={index} style={{ marginBottom: 15 }}>

                    <div className="detail-row">
                      <span>Item:</span>
                      <span>{item.name}</span>
                    </div>

                    <div className="detail-row">
                      <span>Type:</span>
                      <span>{item.type}</span>
                    </div>

                    <div className="detail-row">
                      <span>Category:</span>
                      <span>{item.category}</span>
                    </div>

                    <div className="detail-row">
                      <span>Quantity:</span>
                      <span>{item.quantity}</span>
                    </div>

                    <div className="detail-row">
                      <span>Price:</span>
                      <span>₹ {item.price}</span>
                    </div>

                    <div className="detail-row">
                      <span>Total:</span>
                      <span>₹ {item.price * item.quantity}</span>
                    </div>

                    <hr />
                  </div>
                ))
              ) : (
                <div>No Addons Selected</div>
              )}
            </div>

            {/* ADDONS */}
            {/* <div className="summary-group">
              <h3 className="group-title">Selected Add-Ons</h3>

             {addons && addons.length > 0 ? (
  addons.map((item, index) => (
    <div key={index}>
      {item.name} ({item.type}) × {item.quantity} = ₹ {item.price * item.quantity}
    </div>
  ))
) : (
  <div>No Addons Selected</div>
)}

            </div> */}

          </div>

          {/* RIGHT SIDE */}
          <div className="summary-price-column">

            <div className="price-row">
              Base Total: ₹ {baseTotal}
            </div>

            <div className="price-row">
              Addons: ₹ {addonTotal}
            </div>

            <div className="price-row">
              Tax (18%): ₹ {tax.toFixed(2)}
            </div>

            <div className="price-row">
              <b>Total: ₹ {total.toFixed(2)}</b>
            </div>

            <button
              className="confirm-booking-btn"
              onClick={handleConfirmBooking}
              disabled={saving}
            >
              {saving ? "Confirming..." : "Confirm Booking"}
            </button>
            <Sidebar />
          </div>

        </div>
      </section>

      <AuthPrompt
        open={showAuthPrompt}
        title="Login required"
        message="Please log in or sign up first to confirm your booking."
        primaryLabel="Log In"
        primaryPath="/login"
        secondaryLabel="Sign Up"
        secondaryPath="/signup"
        onClose={() => setShowAuthPrompt(false)}
      />

      {showThankYou ? (
        <div className="ib-modal-overlay">
          <div className="ib-modal-card">
            <div className="ib-modal-accent" />
            <div className="ib-thankyou-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4">
                <path d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h3>Thank you!</h3>
            <p>Your booking has been confirmed successfully.</p>
            <div className="ib-countdown" key={countdown}>
              {countdown}
            </div>
            <p className="ib-countdown-label">Redirecting to home page...</p>
          </div>
        </div>
      ) : null}

      <Footer />
    </>
  );
};

export default ConfirmBooking;
